import React from "react";

const ButtonLink = ({ href, text, bg_color,text_color }) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className=" bg-white/20 text-white font-bold py-2 px-4 outline transition-colors duration-300 hover:bg-white/30outline outline-2 outline-white focus:ring-4 focus:ring-white focus:outline-none rounded-lg"
    
    >
      {text}
    </a>
  );
};

export default ButtonLink;
